import styled from 'styled-components'

export const Title = styled.h1``

export const SubTitle = styled.span`
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: Work Sans;
`

export const SubTitleExtension = styled(SubTitle)`
  font-weight: 400;
  color: #3B3B3B;
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Button = styled.button`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme }) => (disabled ? theme.colors.disabled : theme.colors.blue)};
  font-size: 14px;
`

export const Container = styled.div`
  padding: 0 2rem;
`

export const WrongProductsWrapper = styled.div`
  margin-top: 3.5rem;
`

export const ContainerInfo = styled.div`
  display: flex;
  align-items: start;
  flex-wrap: wrap;
  gap: 2rem;
`
